import jwtDecode from 'jwt-decode'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export const useUserStore = create()(
  devtools(
    persist(
      set => ({
        id: null,
        exp: null,
        iat: null,
        role: null,
        type: null,
        setUser: (user) => {
          localStorage.setItem('jwtToken', user)
          set(jwtDecode(user))
        },
        logout: () => {
          localStorage.removeItem('jwtToken')
          set({ id: null, exp: null, iat: null, role: null, type: null })
        },
      }),
      {
        name: 'user-storage',
      },
    ),
  ),
)
